module.exports = __webpack_public_path__ + "Server-Unavailable.AzureWebApp.087ff7fe63f25bb2716f19aea1d7a523.hashedasset.svg";